export const QUESTION_PRICES = { czk: 579, eur: 23 };

export const prices = {
  data() {
    return {
      prices: QUESTION_PRICES
    };
  }
};
